import { render, staticRenderFns } from "./DefaultRatingCategories.vue?vue&type=template&id=29bf5125&scoped=true&"
import script from "./DefaultRatingCategories.vue?vue&type=script&lang=js&"
export * from "./DefaultRatingCategories.vue?vue&type=script&lang=js&"
import style0 from "./DefaultRatingCategories.vue?vue&type=style&index=0&id=29bf5125&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bf5125",
  null
  
)

export default component.exports